export default "__VITE_ASSET__a5157288__"